// translate.pipe.ts
import { Pipe, PipeTransform, OnDestroy, inject } from '@angular/core';

import { Subscription } from 'rxjs';
import { LanguageStateService } from '../services/language-state.service';

@Pipe({
    name: 'translate',
    pure: false // Important to make it update with language changes
    ,
    standalone: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
    private latestValue: string = '';
    private latestKey: string = '';
    private subscription: Subscription = new Subscription();
    languageService = inject(LanguageStateService);

    constructor() { }

    transform(key: string): string {
        if (key !== this.latestKey) {
            this.latestKey = key;
            this.subscription.unsubscribe();

            this.subscription = this.languageService.currentLanguage$.subscribe(() => {
                this.latestValue = this.languageService.getTranslation(key);
            });

            this.latestValue = this.languageService.getTranslation(key);
        }

        return this.latestValue;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}